import { useCallback, useEffect, useState } from 'react';
import type { JsonFetch } from './settings.api';

export type ResourceState<T> =
  | { status: 'loading' }
  | { status: 'ready'; data: T }
  | { status: 'error'; message: string };

/** Loads one section of the settings screen; the other sections stay idle. */
export function useResource<T>(fetchJson: JsonFetch, path: string): { state: ResourceState<T>; reload: () => void } {
  const [state, setState] = useState<ResourceState<T>>({ status: 'loading' });
  const [tick, setTick] = useState(0);

  useEffect(() => {
    let live = true;
    setState({ status: 'loading' });
    fetchJson<T>(path)
      .then((data) => {
        if (live) setState({ status: 'ready', data });
      })
      .catch((cause: unknown) => {
        if (live) setState({ status: 'error', message: cause instanceof Error ? cause.message : String(cause) });
      });
    return () => {
      live = false;
    };
  }, [fetchJson, path, tick]);

  const reload = useCallback(() => setTick((value) => value + 1), []);
  return { state, reload };
}
